import { render } from "./MobileMenuParentItem.vue?vue&type=template&id=7af44158"
import script from "./MobileMenuParentItem.vue?vue&type=script&lang=js"
export * from "./MobileMenuParentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__